import { Button, Card, CardBody, Heading, HStack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { StatusAccentBar } from "./StatusAccentBar";
import type { StatusVariant } from "./StatusVariant";

interface Props {
  text: string;
  value: boolean | null;
  onChange: (yes: boolean) => void;
  readOnly?: boolean;
}

export const YesNoQuestionCard = ({ text, value, onChange, readOnly }: Props) => {
  const { t } = useTranslation();
  const variant: StatusVariant = value !== null ? "ok" : "neutral";

  return (
    <Card variant="outline" rounded="xl" position="relative" overflow="hidden">
      <StatusAccentBar variant={variant} />
      <CardBody>
        <Heading size="sm" mb="4">
          {text}
        </Heading>
        <HStack spacing="2">
          <Button
            size="sm"
            variant={value === true ? "solid" : "outline"}
            colorScheme="teal"
            isDisabled={readOnly}
            onClick={() => onChange(true)}
          >
            {t("Yes")}
          </Button>
          <Button
            size="sm"
            variant={value === false ? "solid" : "outline"}
            colorScheme="teal"
            isDisabled={readOnly}
            onClick={() => onChange(false)}
          >
            {t("No")}
          </Button>
        </HStack>
      </CardBody>
    </Card>
  );
};
